import { Flex, Text } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["Account", "Town"];

// const items = [
//   {
//     id: 1,
//     Groups: "Bolton",
//   },
// ];

function GroupView() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [listB, setListB] = useState([]);
  const [selectedItemB, setSelectedItemB] = useState();

  const [groupname, setGroupname] = useState();

  // const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();
  const location = useLocation();

  const action = location.state?.action;
  const itemData = location.state?.data;

  const onAddAll = () => {
    setSelectedItem();
    setSelectedItemB();

    let la = JSON.parse(JSON.stringify(list));
    let lb = JSON.parse(JSON.stringify(listB));

    const lbWithAdmins = lb?.filter((a) => a?.data?.usertype === 1);
    const lbWithoutAdmin = lb?.filter((a) => a?.data?.usertype === 2);

    la = [...la, ...lbWithoutAdmin];
    setList(la);
    setListB(lbWithAdmins || []);
  };

  const onSave = async () => {
    console.log("onSave");
    const pl = {};
    pl.groupid = itemData?.groupid;
    pl.groupname = groupname;
    pl.groupmembers_data = [];

    const la = JSON.parse(JSON.stringify(list));
    if (la && la[0]) {
      pl.groupmembers_data = list.map((a) => ({
        groupid: itemData?.groupid,
        dealerid: a?.data?.userid,
      }));
    }

    setIsLoading(true);
    let res;
    if (action === "groupview-edit") {
      if (groupname === itemData?.groupname) {
        pl.groupname = "";
      }

      res = await api.updateGroup(pl);
    } else {
      res = await api.addGroup(pl);
    }

    setIsLoading(false);

    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      // if (action === "groupview-add") {
      onBack();
      // } else {
      // getList({ searchTxt: searchTxt });
      // }
    }
  };

  // const onDeleteAll = () => {
  //   let la = JSON.parse(JSON.stringify(list));
  //   let lb = JSON.parse(JSON.stringify(listB));
  //   lb = [...lb, ...la].sort((a, b) =>
  //     a?.companyname.localeCompare(b?.companyname)
  //   );
  //   setList([]);
  //   setListB(lb);
  // };

  const onDeleteItem = () => {
    setSelectedItem();
    setSelectedItemB();

    const userid = selectedItem?.item?.data?.userid;

    console.log("onDeleteItem userid", userid);

    if (!userid) {
      console.warn("selected item userid ", userid);
      return;
    }

    let la = JSON.parse(JSON.stringify(list));
    console.log("d1", la);
    la = la?.filter((a) => a?.data?.userid !== userid);
    console.log("d3", la);

    setList(la);

    let lb = JSON.parse(JSON.stringify(listB));
    lb = [...lb, selectedItem?.item]?.sort((a, b) =>
      a?.companyname?.label?.localeCompare(b?.companyname?.label)
    );
    setListB(lb);
  };

  const onAddItem = () => {
    setSelectedItem();
    setSelectedItemB();

    // const sgroupid = selectedItemB?.item?.data?.groupid;
    const item = selectedItemB?.item;
    item.data.groupid = itemData.groupid;

    console.log("onAddItem", item);

    let la = JSON.parse(JSON.stringify(list));
    la = [...la, selectedItemB?.item]?.sort((a, b) =>
      a?.companyname?.label?.localeCompare(b?.companyname?.label)
    );
    setList(la);

    let lb = JSON.parse(JSON.stringify(listB));
    lb = lb?.filter((a) => a?.data?.userid !== item?.data?.userid);
    setListB(lb);
  };

  const onSelectItem = (data) => {
    console.log("onSelectItem", data);
    setSelectedItem(data);
    setSelectedItemB();
  };

  const onSelectItemB = (data) => {
    if (data?.item?.data?.usertype === 1) {
      // toaster.create({
      //   title: admin conno,
      //   type: res?.status === 200 ? "success" : "error",
      // });
      return;
    }
    setSelectedItemB(data);
    setSelectedItem();
  };

  const onBack = () => {
    navigate("/managegroups", {
      state: {},
    });
  };

  const getListA = async (data) => {
    setIsLoading(true);
    if (!itemData?.groupid) {
      return;
    }
    api
      .getGroupmembers({
        // page: data?.page || activePage,
        // searchtxt: data?.searchtxt,
        groupid: itemData?.groupid,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("getListA", res.data);

        if (res?.status === 200) {
          if (res?.data && res?.data[0]) {
            const l = res.data.map((item, index) => ({
              id: `groupmem-A-${index}`,
              companyname: {
                label: item?.companyname || "",
                cellStyle: {},
              },
              town: item?.town || "",
              data: item,
            }));

            setList(l);
          } else {
            setList([]);
          }
        } else {
          setList([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const getList = async (data) => {
    setIsLoading(true);

    let group_selected_list = [];
    const list2 = JSON.parse(JSON.stringify(list));
    if (list2 && list2[0]) {
      group_selected_list = list2.map((a) => a?.data?.userid);
    }

    if (data?.searchtxt) {
      setSelectedItem();
      setSelectedItemB();
    }

    api
      .getGroupmembers({
        // page: data?.page || activePage,
        searchtxt: data?.searchtxt,
        group_selected_list,
      })
      .then((res) => {
        setIsLoading(false);

        if (res?.status === 200) {
          console.log("getList", res.data);
          // if (data?.page) {
          //   setActivePage(data.page);
          // }

          if (res?.data && res?.data[0]) {
            const l = res.data.map((item, index) => ({
              id: `groupmem-B-${index}`,
              companyname: {
                label: item?.companyname || "",
                cellStyle:
                  item.usertype === 1
                    ? {
                        color: "textv2.dang",
                        fontWeight: "bold",
                      }
                    : {},
              },

              town: item?.town || "",
              data: item,
            }));

            // if (!data?.searchtxt) {
            //   const listA = l.filter(
            //     (a) => a?.data?.groupid === itemData?.groupid
            //   );
            //   setList(listA);
            // }
            // const listB = l.filter(
            //   (a) => a?.data?.groupid !== itemData?.groupid
            // );
            setListB(l);

            //           l.filter((obj1, i, arr) =>
            // arr.findIndex(obj2 => (obj2.groupid === obj1.groupid)) === i
            // )
          } else {
            // if (!data?.searchtxt) {
            //   setList([]);
            // }
            setListB([]);
          }
        } else {
          // setList([]);
          setListB([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangeSearchTxt = (v) => {
    setSearchTxt(v);
    getList({ searchtxt: v, page: 1 });
    // setSearchLoading(true);
  };

  useEffect(() => {
    console.log("itemData", itemData);
    setGroupname(itemData?.groupname || "");

    const cd = async () => {
      await getListA();
      await getList();
    };
    cd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={"Group"}
        // label={action === "groupview-edit" ? "Group" : "New Group"}
        isLoading={isLoading}
      />
      <Layout type="f-noscroll">
        <InputComp label={"Name"} value={groupname} onChange={setGroupname} />

        <Flex gap={"1rem"} flex={1} overflow={"hidden"}>
          <Flex direction={"column"} gap={"1rem"} w={"50%"}>
            <Flex h={"2.5rem"} alignItems={"end"}>
              <Text>Selected Dealers</Text>
            </Flex>
            <TableList
              type={"simple"}
              headers={headers}
              items={list}
              onSelect={onSelectItem}
              selectedItem={selectedItem}
              // colGroup={["5%", "95%"]}
              // h={"33.5rem"}
              // h={"100%"}
            />
          </Flex>
          <Flex
            direction={"column"}
            gap={"1rem"}
            flex={1}
            overflow={"hidden"}
            w={"50%"}
          >
            <InputComp
              placeholder="Search"
              value={searchTxt}
              onChange={onChangeSearchTxt}
              // loading={searchLoading}
            />
            <TableList
              type={"simple"}
              headers={headers}
              items={listB}
              onSelect={onSelectItemB}
              selectedItem={selectedItemB}
              // colGroup={["5%", "95%"]}
              // h={"33.5rem"}
              // h={"100%"}
            />
          </Flex>
        </Flex>
        <Flex overflow={"hidden"}>
          <Flex w={"50%"}>
            <ButtonComp
              label="Remove"
              keyname="remove"
              disabled={!selectedItem}
              onClick={onDeleteItem}
            />
          </Flex>
          <Flex gap={"1rem"} wrap={"wrap"} justify={"space-between"} w={"50%"}>
            <ButtonComp
              label="Add"
              keyname="group-add"
              disabled={!selectedItemB}
              onClick={onAddItem}
            />
            <ButtonComp
              label="Add All"
              keyname="group-add"
              onClick={onAddAll}
            />
          </Flex>
        </Flex>
      </Layout>

      <Flex
        wrap={"wrap"}
        justifyContent="space-between"
        gap={"1rem"}
        mt={"1rem"}
      >
        <Flex />

        <ButtonComp
          label="Save"
          keyname="save"
          onClick={onSave}
          disabled={isLoading}
        />
      </Flex>
    </Flex>
  );
}

export default GroupView;
